// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"391":"1999af53","488":"2e06328a","589":"75ef9361","616":"9df4be50","777":"fdd62646"}[chunkId] + ".chunk.css";
};